import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserGroup } from '../interfaces/user-group.interface';

@Injectable({
  providedIn: 'root',
})
export class UserGroupService {
  constructor(private readonly http: HttpClient) {}

  public getCurrentUserGroup(params?: HttpParams): Observable<IUserGroup> {
    return this.http.get<IUserGroup>('user-groups/current', { params });
  }

  public getCurrentUserGroups(params?: HttpParams): Observable<IUserGroup[]> {
    return this.http.get<IUserGroup[]>('user-groups', { params });
  }

  public switchUserGroup(userGroupId: string): Observable<IUserGroup> {
    return this.http.post<IUserGroup>(`user-groups/switch/${userGroupId}`, {});
  }
}
